import * as React from 'react';

function SvgTrashCanFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M21 5v-.76a3.76 3.76 0 00-.87-2.76A5.33 5.33 0 0016 .05a5.34 5.34 0 00-4.14 1.43A3.73 3.73 0 0011 4.24V5H4v2h2l1 23h18l1-23h2V5zm-9 19V11.05h2V24zm6 0V11.05h2V24zM13 4.24c0-1 .17-1.22.37-1.45A3.62 3.62 0 0116 2.05a3.61 3.61 0 012.62.74c.2.23.38.44.38 1.45V5h-6z" />
    </svg>
  );
}

export default SvgTrashCanFilled;
